module.exports = __webpack_public_path__ + "media/medal-gold.dfe30e22.mp3";